import { Products } from '@zencity/customer-management-client';
import { SurveyType } from '@zencity/survey-types';
import i18next from 'i18next';
import { SurveysReportGeneratorFilterKey } from 'screens/WidgetGenerator/reportGeneratorComponents/enums';
import { DefinitionKeyPrefixPerProduct } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import '../../../i18n';

export interface ReportBuilderFilterProps {
  onChange: (newValue: unknown) => void;
  value: unknown;
  filterValues: Record<string, unknown>;
}

export const DEFINITION_KEY_PREFIX: DefinitionKeyPrefixPerProduct = {
  [Products.BLOCKWISE]: 'bw',
  [Products.COMMUNITY_SURVEY]: 'cs',
  [Products.PULSE]: 'pul',
};

export const SUPPORTED_SURVEY_TYPES = [SurveyType.COMMUNITY_SURVEY, SurveyType.BLOCKWISE];

export const QUESTIONNAITE_DEFAULT_SPLIT_POSITION = 7;

export const FILTERS_LABELS: Record<SurveysReportGeneratorFilterKey, string> = {
  [SurveysReportGeneratorFilterKey.SURVEY_GROUP]: i18next.t('widgetGenerator.selectSurveyGroup'),
  [SurveysReportGeneratorFilterKey.CLASSIFIED_OPEN_ENDED_GENERIC_QUESTION]: i18next.t('widgetGenerator.selectQuestion'),
  [SurveysReportGeneratorFilterKey.CYCLES]: i18next.t('widgetGenerator.selectCycle'),
  [SurveysReportGeneratorFilterKey.DIVISION]: i18next.t('widgetGenerator.selectDivision'),
  [SurveysReportGeneratorFilterKey.OVERRIDE_COLORS_MAPPING]: i18next.t('widgetGenerator.overrideColorsMapping'),
  [SurveysReportGeneratorFilterKey.DIVISION_SIBLINGS_OR_CHILDREN_TOGGLE]: i18next.t(
    'widgetGenerator.divisionSiblingsOrChildrenToggle',
  ),
  [SurveysReportGeneratorFilterKey.MAINTAIN_AND_FOCUS_FILTERS]: i18next.t(
    'widgetGenerator.filters.maintainAndFocus.filters',
  ),
  [SurveysReportGeneratorFilterKey.SERVICES_BAR_CHART_ROW_TO_DISPLAY]: i18next.t(
    'widgetGenerator.filters.servicesBarChart.rowToDisplay',
  ),
  [SurveysReportGeneratorFilterKey.WORD_CLOUD_GENERIC_QUESTION_SELECT]: i18next.t(
    'widgetGenerator.filters.wordCloud.genericQuestionFilterName',
  ),
  [SurveysReportGeneratorFilterKey.WORD_CLOUD_SHOW_QUESTION_TEXT]: i18next.t(
    'widgetGenerator.filters.wordCloud.showQuestionText',
  ),
  [SurveysReportGeneratorFilterKey.QUESTIONNAIRE_SURVEY_SINGLE_SELECT]: i18next.t(
    'widgetGenerator.filters.questionnaire.selectedSurvey',
  ),
  [SurveysReportGeneratorFilterKey.QUESTIONNAIRE_ASPECTS_SELECT]: i18next.t(
    'widgetGenerator.filters.questionnaire.selectAspect',
  ),
  [SurveysReportGeneratorFilterKey.QUESTIONNAIRE_TABLE_TO_DISPLAY]: i18next.t(
    'widgetGenerator.filters.questionnaire.selectTableToDisplay',
  ),
  [SurveysReportGeneratorFilterKey.QUESTIONNAIRE_TABLE_SPLIT_POSITION]: i18next.t(
    'widgetGenerator.filters.questionnaire.selectSplitPosition',
  ),
  [SurveysReportGeneratorFilterKey.DEMOGRAPHICS_TABLE_ROWS_PER_TABLE]: i18next.t(
    'widgetGenerator.filters.demographics.rowsPerTable.name',
  ),
  [SurveysReportGeneratorFilterKey.TOPICS_BUBBLE_CHART_SCALE_SELECT]: i18next.t(
    'widgetGenerator.filters.topicsBubbleChart.scaleFilter.selectedScale',
  ),
  [SurveysReportGeneratorFilterKey.TOPICS_BUBBLE_CHART_SENTIMENT_SELECT]: i18next.t(
    'widgetGenerator.filters.topicsBubbleChart.scaleFilter.selectedScale',
  ),
  [SurveysReportGeneratorFilterKey.CROSS_TABS_FILTERS]: i18next.t('widgetGenerator.filters.crossTabs.filters'),
  [SurveysReportGeneratorFilterKey.SERVICE_SENTIMENT_BAR_QUESTION_SELECT]: i18next.t(
    'widgetGenerator.filters.serviceSentimentBar.filters.selectBaseQuestion',
  ),
  [SurveysReportGeneratorFilterKey.CHOICES_QUESTION_CHART_QUESTION_SELECT]: i18next.t(
    'widgetGenerator.filters.choicesQuestionChart.selectedQuestion',
  ),
  [SurveysReportGeneratorFilterKey.CHOICES_QUESTION_CHART_DISPLAY_TYPE]: i18next.t(
    'widgetGenerator.filters.choicesQuestionChart.resultsInPercentage',
  ),
  [SurveysReportGeneratorFilterKey.CHOICES_QUESTION_CHART_ORDER_BY]: i18next.t(
    'widgetGenerator.filters.choicesQuestionChart.orderByPopularity',
  ),
  [SurveysReportGeneratorFilterKey.BENCHMARK_ASPECT_SELECT]: i18next.t(
    'widgetGenerator.filters.questionsBenchmarkTable.selectAspect',
  ),
  [SurveysReportGeneratorFilterKey.SERVICES_BAR_CHART_NUM_BARS_PER_ROW]: i18next.t(
    'widgetGenerator.filters.servicesBarChart.numBarsPerTable',
  ),
  [SurveysReportGeneratorFilterKey.SELECTED_SERVICE_BAR_ASPECTS]: i18next.t(
    'widgetGenerator.filters.servicesBarChart.selectAspects',
  ),
  [SurveysReportGeneratorFilterKey.SERVICES_BAR_CHART_TABLE_TO_DISPLAY]: i18next.t(
    'widgetGenerator.filters.servicesBarChart.servicesBarChartTableToDisplay',
  ),
};

export const REPORT_BUILDER_PATH = 'https://d31bg1n95mz22u.cloudfront.net/summary-report';
